<template>
  <form class="form" method="post">

    <div id="appProductsChoiceVueComponent">
      <HeaderApp />
      <div class="appProductCardCreate appFontBlack">
        <h2>Mes Produits ({{ product.length }})</h2>
      </div>
      <div class="appFontBlack">
        <button @click.prevent="createProduct()" type="submit" class="appButtonModel2">Créer un nouveau produit</button>
        <input type="text" v-model="search" class="appSearchBar" placeholder="Rechercher">
      </div>
      <div :key="index" v-for="(product, index) in filteredProducts" class="appProductCardList">
        <div class="appProductCardListLine1">
          <p>{{ product.marque.toUpperCase() }} {{ product.name }}</p>
          <p>Qté : {{ product.quantity }}</p>
        </div>
        <div class="appProductCardListLine2">
          <p>{{ product.category }}</p>
          <p>Prix de vente : {{ product.priceSeller }} €</p>
        </div>
        <button @click.prevent="editProduct(product._id)" type="submit" class="appButtonModel3">Modifier mon
          produit</button>
      </div>
    </div>

  </form>
</template>

<script>
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ProductsList',
  data () {
    return {
      product: '',
      search: ''
    }
  },
  computed: {
    filteredProducts () {
      if (this.product.length > 0) {
        return this.product.filter(product => {
          return product.marque.toLowerCase().includes(this.search.toLowerCase()) ||
          product.name.toLowerCase().includes(this.search.toLowerCase()) ||
          product.category.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }
  },
  mounted () {
    this.getAllProducts()
  },
  methods: {
    getAllProducts () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/produits'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.product = response.data.sort(function tri (a, b) {
            if (a.marque < b.marque) { return -1 }
            if (a.marque === b.marque) { return 0 }
            if (a.marque > b.marque) { return 1 }
          })
        })
    },
    createProduct () {
      this.$router.push('/App/Products/Create')
    },
    editProduct (id) {
      this.$router.push('/App/Products/Edit?id=' + id)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppProductsChoice.vue